import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./NavBar.css";
import { GiHedgehog} from "react-icons/gi";
import { FaBars, FaTimes } from "react-icons/fa";
import { IconContext } from "react-icons/lib";
import { NavLink } from "react-router-dom";

function Navbar() {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  return (
    <>
      <IconContext.Provider value={{ color: "#fff" }}>
        <nav className="navbar">
          <div className="navbar-container container">
            <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
              <span className="navbar-medium-font">Stephen P.</span>
              <GiHedgehog className="navbar-icon" />
            </Link>
            <div className="menu-icon" onClick={handleClick}>
              {click ? <FaTimes /> : <FaBars />}
            </div>
            <ul className={click ? "nav-menu active" : "nav-menu"}>
              <li className="nav-item">
                <NavLink
                  to="/"
                  className={({ isActive }) =>
                    "nav-links navbar-medium-font" + (isActive ? " activated" : "")
                  }
                  onClick={closeMobileMenu}
                >
                  HOME
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/about"
                  className={({ isActive }) =>
                    "nav-links navbar-medium-font" + (isActive ? " activated" : "")
                  }
                  onClick={closeMobileMenu}
                >
                  ABOUT
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="https://github.com/Stephen-Paulsen"
                  className={({ isActive }) =>
                    "nav-links navbar-medium-font" + (isActive ? " activated" : "")
                  }
                  onClick={closeMobileMenu}
                >
                  GITHUB
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/weather"
                  className={({ isActive }) =>
                    "nav-links navbar-medium-font" + (isActive ? " activated" : "")
                  }
                  onClick={closeMobileMenu}
                >
                  WEATHER
                </NavLink>
              </li>
            </ul>
          </div>
        </nav>
      </IconContext.Provider>
    </>
  );
}

export default Navbar;